import { Link, useLocation } from "react-router-dom";
import { MyColor } from "../config/myStyle";
import { useTranslation } from "react-i18next";

// 国际化 label key 映射
const breadcrumbMap: { pattern: string, labelKey: string }[] = [
  { pattern: "/", labelKey: "breadcrumb.home" },
  { pattern: "/campaign/create", labelKey: "breadcrumb.host_a_fundraiser" },
  { pattern: "/campaign/:campaignId", labelKey: "breadcrumb.campaign" },
  { pattern: "/campaign/create/select-type", labelKey: "breadcrumb.select_type" },
  { pattern: "/campaign/create/form", labelKey: "breadcrumb.fill_form" },
  { pattern: "/campaign/create/success", labelKey: "breadcrumb.created_successfully" },
  { pattern: "/donation", labelKey: "breadcrumb.donate" },
  { pattern: "/donation-select", labelKey: "breadcrumb.select_donation_target" },
  { pattern: "/donation/:campaignId", labelKey: "breadcrumb.campaign" },
  { pattern: "/donation/:campaignId/amount", labelKey: "breadcrumb.select_amount" },
  { pattern: "/donation/:campaignId/amount/receipt/:donationId", labelKey: "breadcrumb.select_receipt" },
  { pattern: "/donation/:campaignId/amount/history/:donationId", labelKey: "breadcrumb.select_anonymous" },
  { pattern: "/donation/:campaignId/amount/result", labelKey: "breadcrumb.donation_completed" },
  { pattern: "/my-record", labelKey: "breadcrumb.your_records" },
  { pattern: "/my-record/total-raised", labelKey: "breadcrumb.total_raised" },
  { pattern: "/my-record/donation-amount", labelKey: "breadcrumb.total_donations" },
  { pattern: "/my-record/:campaignId", labelKey: "breadcrumb.campaign" },
  { pattern: "/login", labelKey: "breadcrumb.login" },
  { pattern: "/register/form-a", labelKey: "breadcrumb.register" },
  { pattern: "/register/form-b", labelKey: "breadcrumb.register" },
  { pattern: "/register/success", labelKey: "breadcrumb.registration_successful" },
  { pattern: "/contact-us", labelKey: "breadcrumb.contact_us" },
  { pattern: "/donate", labelKey: "breadcrumb.donate" },
  { pattern: "/fundraising", labelKey: "breadcrumb.fundraising" },
  { pattern: "/error", labelKey: "breadcrumb.error" },
  { pattern: "*", labelKey: "breadcrumb.page_not_found" }
];

function matchPattern(pattern: string, path: string) {
  const patternParts = pattern.split("/").filter(Boolean);
  const pathParts = path.split("/").filter(Boolean);
  if (patternParts.length !== pathParts.length) return false;
  for (let i = 0; i < patternParts.length; i++) {
    if (patternParts[i].startsWith(":")) continue;
    if (patternParts[i] !== pathParts[i]) return false;
  }
  return true;
}

function getPathSegments(pathname: string) {
  const segments: string[] = [];
  const arr = pathname.split("/").filter(Boolean);
  for (let i = 0; i < arr.length; i++) {
    segments.push("/" + arr.slice(0, i + 1).join("/"));
  }
  return segments;
}

const BreadCrumb = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const pathname = location.pathname;
  const paths = getPathSegments(pathname);

  if (pathname === "/" || pathname === "") {
    return <div />;
  }
  const crumbs = [
    <Link to="/" key="home" style={{ color: MyColor.sub }}>{t("breadcrumb.home")}</Link>,
    " / "
  ];
  paths.forEach((seg, idx) => {
    const matched = breadcrumbMap.find(item => matchPattern(item.pattern, seg));
    if (matched) {
      const isLast = idx === paths.length - 1;
      if (isLast) {
        crumbs.push(
          <span key={seg} style={{ color: MyColor.blue }}>
            {t(matched.labelKey)}
          </span>
        );
      } else {
        crumbs.push(
          <Link to={seg} key={seg} style={{ color: MyColor.sub }}>
            {t(matched.labelKey)}
          </Link>
        );
        crumbs.push(" / ");
      }
    }
  });

  return (
    <div className="text-[12px] px-[15px]">
      {crumbs}
    </div>
  );
};

export default BreadCrumb;
